import { render } from "./ProductRefill.vue?vue&type=template&id=7f387f36"
import script from "./ProductRefill.vue?vue&type=script&lang=js"
export * from "./ProductRefill.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/product/ProductRefill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f387f36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f387f36', __exports__)) {
    api.reload('7f387f36', __exports__)
  }
  
  module.hot.accept("./ProductRefill.vue?vue&type=template&id=7f387f36", () => {
    api.rerender('7f387f36', render)
  })

}


export default __exports__